import { Laptop, Monitor } from "lucide-react";
import { Choice, Field, inputCls } from "./Field";

export const StepDevice = ({ f, set, errors }) => (
  <div className="space-y-8">
    <div className="grid gap-4 sm:grid-cols-2">
      <Choice testId="device-laptop-option" active={f.device_type === "laptop"} onClick={() => set("device_type", "laptop")} icon={Laptop} title="Laptop" text="Notebooks, ultrabooks, MacBooks, gaming laptops" />
      <Choice testId="device-desktop-option" active={f.device_type === "desktop"} onClick={() => set("device_type", "desktop")} icon={Monitor} title="Desktop" text="Towers, all-in-ones, gaming PCs, workstations" />
    </div>
    {errors.device_type && <p className="text-xs text-red-400">{errors.device_type}</p>}
    <Field label="Brand & model" hint="e.g. Dell XPS 15 9520, HP Pavilion, custom build" error={errors.brand_model}>
      <input data-testid="brand-model-input" className={inputCls} value={f.brand_model} onChange={(e) => set("brand_model", e.target.value)} placeholder="Brand and model" />
    </Field>
  </div>
);
